const errorMessages = {
    400: "Bad Request: The server could not understand the request.",
    401: "Unauthorized: Access is denied due to invalid credentials.",
    403: "Forbidden: You do not have permission to access this resource.",
    404: "Not Found: The requested resource could not be found.",
    405: "Method Not Allowed: The requested method is not supported.",
    408: "Request Timeout: The server timed out waiting for the request.",
    409: "Conflict: The request could not be completed due to a conflict.",
    500: "Internal Server Error: Something went wrong on the server.",
    502: "Bad Gateway: The server received an invalid response.",
    503: "Service Unavailable: The server is currently unavailable.",
    504: "Gateway Timeout: The server took too long to respond.",
  };
  
  export default errorMessages;
  